import { User } from 'interfaces';
import { useSelector } from 'react-redux';
import { userDataSelector } from 'store/reducers/user-reducer';

export default function useUserData(): User {
  const user: User = useSelector(userDataSelector);

  return user;
}
